import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getblogAPi, createblogAPi, uploadblogAPi, deleteblogApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// create blog
export const createblog = createAsyncThunk('createblog/blog', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createblogAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateblog = createAsyncThunk('updateblog/blog', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadblogAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get blog
export const getblog = createAsyncThunk('getblog/blog', async () => {
    try {
        const response = await axios.get(`${getblogAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'blogs' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete blog
export const deleteblogs = createAsyncThunk('deleteblogs/blog', async (blogid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteblogApi}/${blogid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'blogid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const blogSlice = createSlice({
    name: 'blog',
    initialState: {
        blogs: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create blog
            .addCase(createblog.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createblog.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createblog.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update blog
            .addCase(updateblog.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateblog.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updateblog.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getblogs
            .addCase(getblog.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getblog.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.blogs = action.payload;
            })
            .addCase(getblog.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete blogs
            .addCase(deleteblogs.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteblogs.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.blogs.data = state.blogs.data.filter(blogs => blogs.blogid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteblogs.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default blogSlice.reducer;
